// src/components/Header.js
import React, { useContext } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box
} from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { AuthContext } from '../util/AuthContext';
import logoImg from '../../assets/img/logo.png';

const Header = () => {
  const { isAuthenticated, setAuthenticated, user, setUser} = useContext(AuthContext);
  const location = useLocation();

  const handleLogout = async () => {
    if(window.confirm("로그아웃 하시겠습니까?")){
      try {
        const response = await fetch('/api/logout', {
          method: 'POST',
          credentials: 'include', // 세션 쿠키 전달
        });
        if (response.ok) {
          setAuthenticated(false);
          setUser(false);
          // 추가로 사용자 정보도 초기화
        } else {
          console.error('로그아웃 실패');
        }
      } catch (error) {
        console.error('로그아웃 에러:', error);
      }
    };
  };

  // 헤더 중앙에 들어갈 네비게이션 메뉴 배열 (공사현황, 견적관리, 자재관리)
  const navLinks = [
    { label: '공사현황', path: '/' },
    // { label: '외주관리', path: '/outsourcing' },
    { label: '견적관리', path: '/estimate' },
    { label: '자재관리', path: '/material' },
    { label: '일정관리', path: 'https://intra.hskt.kr'}
  ];
  
  return (
    <AppBar
      position="fixed"
      sx={{ 
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: 'transparent', 
        boxShadow: 'none',
        zIndex: theme => theme.zIndex.appBar, // 다른 콘텐츠 위로 올라오게
      }}
    >
      <Toolbar>
        {/* 80% 너비의 중앙 박스 */}
        <Box
          sx={{
            backgroundColor: 'white',
            px: 2,
            py: 1,
            width: '80%',
            mx: 'auto',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center', // 수직 중앙정렬
            borderRadius: '8px', // 라운드 값 추가
            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)', // 그림자 값 추가
          }}
        >
          {/* 왼쪽: 프로젝트 로고 */}
          <Typography variant="h6" sx={{ color: 'black' }}>
            <a href = "/"><img src={logoImg} alt="프로젝트 로고" style={{ height: '45px' }} /></a>
          </Typography>

          {/* 중앙: 네비게이션 메뉴 (메뉴 모두 표시) */}
          <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
            {navLinks.map((link) => (
              <Button
                key={link.path}
                component={Link}
                to={link.path}
                sx={{
                  color: 'black',
                  fontWeight: location.pathname === link.path ? 'bold' : 'normal',
                  mx: 2,
                  borderBottom: location.pathname === link.path ? '1px solid #ccc' : '', // 하단 실선
                }}
              >
                {link.label}
              </Button>
            ))}
          </Box>

          {/* 오른쪽: 사용자 정보와 로그아웃 버튼 */}
          {isAuthenticated && (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="body1" sx={{ color: 'black', marginRight: 2 }}>
                {user?.userNick || 'User'}
              </Typography>
              <Button variant="text" onClick={handleLogout}>
                로그아웃
              </Button>
            </Box>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
